module.exports = __webpack_public_path__ + "sprite.aaccd643aee8d6e716e4.png";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/sprite.png
// module id = ../../../../../src/assets/img/sprite.png
// module chunks = styles